import { render, staticRenderFns } from "./DashboardSidebarSettingsBlock.vue?vue&type=template&id=0a78cd81"
import script from "./DashboardSidebarSettingsBlock.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarSettingsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports